import { memo } from "react";
import { useSelector } from "react-redux";
import { fetchDocuments, resetTabState, updateRequestBody } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import TableComponent from "../../TableComponent/TableComponent";
import EngageTranslateAllTableColumns from "../TableComponent/EngageTranslateAllTableColumns";

function AllContent(props: any) {
  const dispatch = useAppDispatch();
  const allTabState = useSelector((state: RootState) => state.engageTranslationState.allTabState);

  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = { ...allTabState.currentRequestBody, sortColumn: sorter.field, isAsc: isAscend(sorter.order) };
    dispatch(resetTabState("all"));
    dispatch(updateRequestBody({ requestBody: newSortingRequestBody, view: "all" }));
    dispatch(fetchDocuments({ view: "all" }));
  };

  return (
    <div className="d-flex flex-column full-flex h-100 mt-2 px-2">
      <div className="d-flex flex-column full-flex gap-3 overflow-hidden">
        <TableComponent
          dataSource={allTabState.data}
          tableKey={"all"}
          columns={EngageTranslateAllTableColumns}
          loading={allTabState.loading}
          pagination={allTabState.pagination}
          handleTableSorting={handleTableSorting}
        />
      </div>
    </div>
  );
}

export default memo(AllContent);
